import { AuthView } from "./types";

interface LocalizationData {
  button_label: string;
  loading_button_label: string;
  email_label: string;
  email_input_placeholder: string;
  password_label?: string;
  password_input_placeholder?: string;
}

export const getLocalization = (view: AuthView): LocalizationData => {
  switch (view) {
    case "sign_in":
      return {
        button_label: "Access My Account",
        loading_button_label: "Signing you in...",
        email_label: "Email",
        email_input_placeholder: "Enter your email",
        password_label: "Password",
        password_input_placeholder: "Enter your password",
      };
    case "sign_up":
      return {
        button_label: "Start Free Trial",
        loading_button_label: "Creating your account...",
        email_label: "Email",
        email_input_placeholder: "Enter your email",
        password_label: "Password",
        password_input_placeholder: "Create a secure password",
      };
    case "forgot_password":
      return {
        button_label: "Send Reset Instructions",
        loading_button_label: "Sending instructions...",
        email_label: "Email",
        email_input_placeholder: "Enter your email",
      };
    case "reset_password":
      return {
        button_label: "Update Password",
        loading_button_label: "Updating password...",
        email_label: "Email",
        email_input_placeholder: "Your email",
        password_label: "New Password",
        password_input_placeholder: "Create a new secure password",
      };
    case "verification_code":
      return {
        button_label: "Verify & Continue",
        loading_button_label: "Verifying...",
        email_label: "Email",
        email_input_placeholder: "Your email",
      };
    default:
      return {
        button_label: "Continue",
        loading_button_label: "Processing...",
        email_label: "Email",
        email_input_placeholder: "Enter your email",
      };
  }
};
